import { Directive, ElementRef, HostListener, Input, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { FormateadorService } from '@shared/service/app/formateador.service';

@Directive({
    selector: '[appFormatInput]',
})
export class InputFormatDirective {
    @Input() appFormatInput: 'percentage' | 'currency' = 'percentage';
    @Input() formatCurrencyType: number = 0;

    constructor(
        private el: ElementRef,
        private control: NgControl,
        private formateador: FormateadorService
    ) {}

    @HostListener('input', ['$event.target.value'])
    onInput(value: string): void {
        // Limpiar el valor de entrada
        const cleanedValue = this.formateador.formatInput(value);
        this.control.control.setValue(cleanedValue, { emitEvent: false });
    }

    @HostListener('blur')
    onBlur(): void {
        if (this.appFormatInput === 'percentage') {
            this.formateador.onPercentageBlur(this.control.control);
        } else if (this.appFormatInput === 'currency') {
            this.formateador.onCurrencyBlur(this.control.control, this.formatCurrencyType);
        }
    }
}
